var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 18,
    viewBox: "0 0 4 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.5C1 0.951142 1.45114 0.5 2 0.5C2.54886 0.5 3 0.951142 3 1.5C3 2.04886 2.54886 2.5 2 2.5C1.45114 2.5 1 2.04886 1 1.5ZM1 16.5C1 15.9511 1.45114 15.5 2 15.5C2.54886 15.5 3 15.9511 3 16.5C3 17.0489 2.54886 17.5 2 17.5C1.45114 17.5 1 17.0489 1 16.5ZM1 9C1 8.45114 1.45114 8 2 8C2.54886 8 3 8.45114 3 9C3 9.54886 2.54886 10 2 10C1.45114 10 1 9.54886 1 9Z",
    fill: "#16181A",
    stroke: "#262930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.fa1b6a65b5ae33a82f9cbe3fab23d80a.svg";
export { ForwardRef as ReactComponent };